import axios from 'axios';

export default axios.create({
    baseURL: 'https://backend.mercylandgroup.com/api'
});